const state = {

    comments: '',
    questions: '',
};

const mutations = {


    /*obtengo el companyId del usuario*/
    comments: function (state, comments) {
        state.comments = comments;
    },
    questions: function (state, questions) {
        state.questions = questions;
    },

};

const actions = {};

const getters = {
    comment(state) {
        return state.comments
    },
    allQuestions(state) {
        return state.questions
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
}